import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LOCALE, DEFAULT_NS } from "../../translations/config";

import commonEn from "../../translations/en/common.json";
import landingEn from "../../translations/en/landing.json";
import dashboardEn from "../../translations/en/dashboard.json";
import authEn from "../../translations/en/auth.json";
import seoEn from "../../translations/en/seo.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: commonEn,
      landing: landingEn,
      dashboard: dashboardEn,
      auth: authEn,
      seo: seoEn,
    },
  },
  lng: DEFAULT_LOCALE,
  fallbackLng: "en",
  defaultNS: DEFAULT_NS,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
